import React, { PureComponent } from 'react'
import styles from './styles'

export default class MissionStatement extends PureComponent {
  static propTypes = {
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.box}>
            <h2>The Goal is To Live a Life of Passion.</h2>
            <p>
              To immerse ourselves in our pursuits and be valued for our
              accomplishments. We want the courage to explore who we are
              because we're not done yet - not even close. Our blood still runs
              hot through our veins as we reach for our highest dreams and
              deepest desires. We are our country's greatest human resource
              that holds the ability to affect young lives, the world, and both
              of their futures.
            </p>
            <p className={styles.credit}>
              <span>-Dr. David Gottlieb, Chairman of the Advisory Board</span>
              <span>&nbsp;Super Adult Advocate</span>
            </p>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/MissionStatement/MissionStatement.js
 **/